import { render } from "./App.vue?vue&type=template&id=1735b41a"
const script = {}

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__